import React from "react";
import "./index.css";
import AgenticAITargetUI from "./pages/AgenticAITargetUI";
import PubMedTester from "./utils/PubMedTester"; // Import the tester

export default function App() {
  return (
    <>
      <AgenticAITargetUI />
    </>
  );
}